import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, character, onConfirm, isDeleting }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e?.key === 'Escape' && isOpen && !isDeleting) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose, isDeleting]);

  if (!isOpen || !character) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={!isDeleting ? onClose : undefined}
      />
      <div className="relative w-full max-w-md bg-card rounded-xl shadow-warm-2xl">
        <div className="p-6 md:p-8">
          <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-error/20 flex items-center justify-center mx-auto mb-4 md:mb-6">
            <Icon name="AlertTriangle" size={32} color="var(--color-error)" />
          </div>

          <h2 className="text-xl md:text-2xl font-semibold text-center mb-3 md:mb-4">
            Delete Character?
          </h2>

          <p className="text-sm md:text-base text-muted-foreground text-center mb-6 md:mb-8">
            Are you sure you want to delete <span className="font-semibold text-foreground">{character?.name}</span>? This action cannot be undone and all progression data will be permanently lost.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isDeleting}
              fullWidth
            >
              Cancel
            </Button>
            
            <Button
              variant="destructive"
              onClick={onConfirm}
              loading={isDeleting}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Delete Character
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;